import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV,
  tracesSampleRate: 0.2,
});

// This app's real error-handling convention, at ~57 call sites across the
// codebase, is `console.error(...); return;` on a failed Supabase call —
// not throwing. The ErrorBoundary below only catches things that crash a
// render, so on its own it would miss almost every real failure this app
// has. Hooking console.error forwards every existing call site to Sentry
// with zero changes needed anywhere else.
const originalConsoleError = console.error;
console.error = (...args) => {
  originalConsoleError(...args);
  Sentry.captureMessage(
    args.map(a => (a instanceof Error ? a.message : String(a))).join(' '),
    'error'
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(registration => {
      console.log('[SW] Registered:', registration.scope);
    }).catch(err => {
      console.warn('[SW] Registration failed:', err);
    });
  });

  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}
